import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowLeftSmallOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" stroke="currentColor" strokeWidth={0.5} d="m5.914 11.364 5.51-5.51a.5.5 0 1 0-.706-.708L4 11.864l6.718 6.717a.5.5 0 1 0 .707-.707l-5.51-5.51H19.5a.5.5 0 0 0 0-1z" /></svg>
);
